import { withNamespaces } from 'react-i18next';

import DateContainer from "./DateContainer";

export default withNamespaces(['common'])(DateContainer);
